/**
 * Bundle & Save Widget — Pitchers Only  (metaobject-driven)
 * Reads the current product's bundle from window.PO_BUNDLE (emitted by the
 * po-upsell-widgets snippet straight from the cro.bundle product metafield →
 * bundle metaobject). Shopify is the source of truth; no bundle-rules.json
 * fetch. Discount + whole-dollar round-down are applied at checkout by the
 * existing po-widget-discount Shopify Function via the _po_discount property.
 * Vanilla JS, no dependencies.
 *
 * 5-YEAR SALE (Chris, 2026-09-07): the bundle shows on every PDP, but a member
 * tagged 5yr- (PO_BUNDLE "sale": true, or its own product tags) gets NO bundle
 * discount: it is priced at its sale price with the compare-at struck. The
 * bundle discount and the whole-dollar round-down run on the full-price
 * members only, exactly as the bundle-pricing Function computes it (sale
 * lines still count toward the 3-line gate, never receive money). Every
 * member is stamped _po_widget=bundle (attribution + the 3-line gate); only a
 * full-price member gets _po_discount. Both the live po-bundle-kit-discount
 * Function and its bundle-pricing port treat a bundle line without a usable
 * _po_discount as "counts toward the 3, not discounted", so the rule holds
 * with either Function deployed; bundle-pricing additionally refuses sale
 * lines from the product tags. All-sale bundle: "Sale prices already
 * applied", no savings claim.
 */
(function () {
  'use strict';


  function fmt(cents) { return '$' + (cents / 100).toFixed(2); }

  function getSessionId() {
    try {
      var key = 'po_session_id';
      var id = sessionStorage.getItem(key);
      if (!id) { id = 'sess_' + Date.now() + '_' + Math.random().toString(36).slice(2, 9); sessionStorage.setItem(key, id); }
      return id;
    } catch (e) { return 'sess_unknown'; }
  }

  var ANALYTICS_URL = 'https://dashboard-production-d03c.up.railway.app';
  var BUNDLE_WIDGET_ID = 3;

  function trackEvent(eventType, rule, extra) {
    if (!ANALYTICS_URL) return;
    try {
      fetch(ANALYTICS_URL + '/api/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify({
          event_type: eventType, widget_id: BUNDLE_WIDGET_ID,
          rule_id: rule ? rule.id : null, session_id: getSessionId(), metadata: extra || {}
        })
      }).catch(function () {});
    } catch (e) {}
  }

  // Which bundle this event is about. The beacon carried counts only
  // (product_count / item_count), so an impression said "someone saw a bundle"
  // without saying which one — same blind spot complete-look.js had. These are
  // the fields the CTL beacon now sends, so both widgets report one shape and
  // trigger joins to the _po_trigger already on the cart line.
  function bundleMeta(products, extra) {
    var pp = getPageProduct();
    var out = {
      trigger: pp && pp.id ? String(pp.id) : '',
      trigger_handle: pp && pp.handle ? pp.handle : '',
      offered: (products || []).map(function (p) {
        return p && p.id ? String(p.id) : '';
      }).filter(Boolean).join(','),
      offered_handles: (products || []).map(function (p) {
        return p && p.handle ? p.handle : '';
      }).filter(Boolean).join(',')
    };
    for (var k in (extra || {})) {
      if (Object.prototype.hasOwnProperty.call(extra, k)) out[k] = extra[k];
    }
    return out;
  }

  // Fire once, and only when the element is genuinely on screen. This used to
  // fire the instant the widget was inserted into the DOM, which meant an
  // "impression" recorded that the page had rendered the widget, not that anyone
  // saw it. CTL mounts above the buy button and this widget mounts below it, so
  // the two widgets' rates were never comparable — part of the gap between them
  // was scroll depth, not performance. Half the widget visible is the bar.
  //
  // Browsers without IntersectionObserver keep the old behaviour rather than
  // losing the event entirely; that is a rounding error of traffic.
  function whenSeen(el, fn) {
    if (typeof IntersectionObserver === 'undefined') { fn(); return; }
    var fired = false;
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting && !fired) {
          fired = true;
          io.disconnect();
          fn();
        }
      }
    }, { threshold: 0.5 });
    io.observe(el);
  }

  // The size the shopper has already chosen on this page. They told us once;
  // making them say it again for every bundle member is the whole friction.
  // Only a size they CHOSE counts: a ?variant= in the URL, or a change on the
  // page's own picker (mainSizePicked). On a plain page load the form holds the
  // theme's default, the first in-stock size (S / YS), and pre-filling that
  // put the smallest size on every member before anyone picked (10/6 probe).
  var mainSizePicked = /[?&]variant=\d/.test(window.location.search);
  // A pick made before the widget renders (members load async) still counts.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && !t.closest('.po-bundle-widget')) mainSizePicked = true;
  }, true);
  function selectedMainSize() {
    if (!mainSizePicked) return null;
    try {
      var form = document.querySelector('form[action*="/cart/add"]');
      var input = form && form.querySelector('[name="id"]');
      var vid = input && String(input.value);
      if (!vid) return null;
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta
              && window.ShopifyAnalytics.meta.product;
      var vs = (meta && meta.variants) || [];
      for (var i = 0; i < vs.length; i++) {
        if (String(vs[i].id) === vid) {
          return String(vs[i].public_title || '').trim() || null;
        }
      }
    } catch (e) {}
    return null;
  }

  function getPageProduct() {
    var liquidTitle = window.PO_PRODUCT_TITLE || null;
    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
        var p = window.ShopifyAnalytics.meta.product;
        return { id: p.id, handle: p.handle || '', title: p.title || liquidTitle || '' };
      }
    } catch (e) {}
    try {
      var canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) { var m = canonical.href.match(/\/products\/([^/?#]+)/); if (m) return { id: null, handle: m[1], title: liquidTitle || '' }; }
    } catch (e) {}
    return null;
  }

  // Tops fill tops and bottoms fill bottoms, nothing else. A shopper's tee
  // size says nothing about their shorts size (Chris 10/6: "if its top and
  // bottom the size could be different").
  var TOPS = ['t-shirt', 't-shirts', 'hoodie', 'jackets', 'tank top', 'short sleeve hoodie', 'long sleeve t-shirt', 'sweatshirt'];
  var BOTTOMS = ['shorts', 'joggers'];
  function garmentClass(product) {
    var t = String((product && product.type) || '').trim().toLowerCase();
    if (TOPS.indexOf(t) !== -1) return 'top';
    if (BOTTOMS.indexOf(t) !== -1) return 'bottom';
    return null;
  }

  function isPreorderProduct(p) {
    if (!p) return false;
    var groups = p.selling_plan_groups || [];
    for (var i = 0; i < groups.length; i++) {
      var name = (groups[i] && groups[i].name) || '';
      if (name.indexOf('Preorder:') === 0) return true;
    }
    return false;
  }

  // True when this member must NOT get the bundle discount: the Liquid bridge
  // flagged its handle, or /products/<handle>.js carries a 5yr- tag.
  function isSaleMember(product, rule) {
    if (!product) return false;
    if (rule && rule.sale_handles && product.handle && rule.sale_handles[product.handle]) return true;
    var tags = product.tags || [];
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i]).indexOf('5yr-') === 0) return true;
    }
    return false;
  }

  function compareAtCents(product) {
    var v = (product.variants || [])[0];
    var c = (v && v.compare_at_price) || product.compare_at_price || 0;
    return parseInt(c, 10) || 0;
  }

  function fetchProductByHandle(handle) {
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin', headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('Product not found: ' + handle); return r.json(); });
  }

  // ─── Render (unchanged pricing: total rounds DOWN to whole $ to match Function) ──
  function discountedPrice(priceInCents, discountPct) {
    var raw = priceInCents * (1 - discountPct / 100);
    return Math.floor(raw / 100) * 100 + 99; // per-item cosmetic only
  }

  function buildSizeSelect(product, idx, pageClass, isPageMember) {
    var select = document.createElement('select');
    select.className = 'po-bundle-size-btn';
    select.dataset.productId = product.id;
    select.dataset.productIdx = idx;
    var variants = product.variants || [];
    var availableVariants = variants.filter(function (v) { return v.available; });
    if (variants.length <= 1) {
      select.style.display = 'none';
      var solo = availableVariants[0] || variants[0];
      if (solo) { var soloOpt = document.createElement('option'); soloOpt.value = solo.id; soloOpt.selected = true; select.appendChild(soloOpt); }
      return select;
    }
    // Pre-select the size the shopper already picked on this page, when this
    // product has that exact size AND it is in stock. Deliberately strict: an
    // exact string match on the variant title only. Adult "M" will not fill a
    // youth "YM", a hat's "One Size" will not fill a tee, and a sold-out size
    // is never chosen. Anything it is unsure about is left on Select Size, so
    // the failure mode is the behaviour we have today, not a wrong size.
    var wantedSize = selectedMainSize();
    var preselected = null;
    var sameClass = isPageMember || (pageClass && garmentClass(product) === pageClass);
    if (wantedSize && sameClass) {
      for (var w = 0; w < availableVariants.length; w++) {
        if (String(availableVariants[w].title).trim() === wantedSize) {
          preselected = availableVariants[w];
          break;
        }
      }
    }
    if (preselected) select.dataset.preselected = '1';

    var placeholder = document.createElement('option');
    placeholder.value = ''; placeholder.textContent = 'Select Size'; placeholder.disabled = true;
    placeholder.selected = !preselected;
    select.appendChild(placeholder);
    availableVariants.forEach(function (v) {
      var opt = document.createElement('option');
      opt.value = v.id; opt.textContent = v.title !== 'Default Title' ? v.title : 'One Size';
      if (preselected && v.id === preselected.id) opt.selected = true;
      select.appendChild(opt);
    });
    return select;
  }

  function renderWidget(products, rule) {
    if (!products || products.length < 2) return;
    if (document.querySelector('.po-bundle-widget')) return;
    var discountPct = rule.discount_percent || 15;

    // Split members: sale members are charged their sale price untouched; the
    // bundle percentage and the whole-dollar round-down apply to the
    // full-price (eligible) members only. Same math as the bundle-pricing
    // Function's round_down_discount(eligible gross, pct).
    var eligibleGross = 0, saleGross = 0, eligibleCount = 0;
    products.forEach(function (p) {
      if (isSaleMember(p, rule)) { saleGross += p.price; }
      else { eligibleGross += p.price; eligibleCount++; }
    });
    var totalOriginal = eligibleGross + saleGross;
    var eligibleCharged = eligibleCount
      ? Math.floor(eligibleGross * (1 - discountPct / 100) / 100) * 100 // whole dollars DOWN — matches Function
      : 0;
    if (eligibleCharged < 0) eligibleCharged = 0;
    var totalSavings = eligibleGross - eligibleCharged;
    var totalDiscounted = totalOriginal - totalSavings;

    var widget = document.createElement('div');
    widget.className = 'po-bundle-widget';
    widget.dataset.ruleId = rule.id || '';
    // none | mixed | all: bundle-save.css swaps the heading sub-line so it
    // never promises 15% on a sale member.
    var saleCount = products.length - eligibleCount;
    widget.setAttribute('data-po-sale-mix', saleCount === 0 ? 'none' : (saleCount === products.length ? 'all' : 'mixed'));

    var heading = document.createElement('h3');
    heading.className = 'po-bundle-heading';
    heading.textContent = rule.heading || 'BUNDLE & SAVE';
    widget.appendChild(heading);

    var pageInfo = getPageProduct();
    var ph = pageInfo && pageInfo.handle;
    var pageMember = products.filter(function (p) { return p.handle === ph; })[0];
    var pageClass = garmentClass(pageMember || (window.ShopifyAnalytics && window.ShopifyAnalytics.meta
                                                && window.ShopifyAnalytics.meta.product));

    var grid = document.createElement('div');
    grid.className = 'po-bundle-grid';
    products.forEach(function (product, idx) {
      var memberSale = isSaleMember(product, rule);
      // Sale member: its price IS the price; strike its compare-at if any.
      // Full-price member: cosmetic .99 markdown, regular price struck.
      var orig = memberSale ? compareAtCents(product) : product.price;
      var disc = memberSale ? product.price : discountedPrice(product.price, discountPct);
      var item = document.createElement('div');
      item.className = 'po-bundle-item';
      if (memberSale) item.setAttribute('data-po-sale', '1');
      var img = document.createElement('img');
      img.className = 'po-bundle-image';
      var imgSrc = product.featured_image || (product.images && product.images[0] && product.images[0].src) || '';
      img.src = imgSrc.replace(/(\.[a-z]+)(\?|$)/, '_300x300$1$2');
      img.alt = product.title || ''; img.loading = 'lazy';
      item.appendChild(img);
      var title = document.createElement('div');
      title.className = 'po-bundle-title'; title.textContent = product.title || '';
      item.appendChild(title);
      var prices = document.createElement('div');
      prices.className = 'po-bundle-prices';
      var sale = document.createElement('span'); sale.className = 'po-bundle-sale'; sale.textContent = fmt(disc); prices.appendChild(sale);
      if (orig > disc) {
        var original = document.createElement('span'); original.className = 'po-bundle-original'; original.textContent = fmt(orig); prices.appendChild(original);
      }
      item.appendChild(prices);
      item.appendChild(buildSizeSelect(product, idx, pageClass, product.handle === ph));
      grid.appendChild(item);
    });
    widget.appendChild(grid);

    var savings = document.createElement('div');
    savings.className = 'po-bundle-savings';
    // No eligible savings (every shown member is a sale item): no "Save $X"
    // claim, say why instead.
    savings.textContent = totalSavings > 0 ? 'Save ' + fmt(totalSavings) : 'Sale prices already applied';
    widget.appendChild(savings);

    var total = document.createElement('div');
    total.className = 'po-bundle-total';
    var totalLabel = document.createElement('span'); totalLabel.className = 'po-bundle-total-label'; totalLabel.textContent = 'Total Price:'; total.appendChild(totalLabel);
    if (totalSavings > 0) {
      var totalOrig = document.createElement('span'); totalOrig.className = 'po-bundle-total-original'; totalOrig.textContent = fmt(totalOriginal); total.appendChild(totalOrig);
    }
    var totalSale = document.createElement('span'); totalSale.className = 'po-bundle-total-sale'; totalSale.textContent = fmt(totalDiscounted); total.appendChild(totalSale);
    widget.appendChild(total);
    widget.setAttribute('data-po-savings-cents', String(totalSavings));

    var addBtn = document.createElement('button');
    addBtn.className = 'po-bundle-add-btn'; addBtn.textContent = 'ADD TO CART'; addBtn.disabled = true;
    widget.appendChild(addBtn);

    var selects = grid.querySelectorAll('.po-bundle-size-btn');

    // Funnel instrumentation (2026-07-28). Previously the only events were
    // 'impression' and 'click', and 'click' fires only AFTER a successful cart
    // add. That hid the step that matters: ADD TO CART stays disabled until a
    // size is chosen for EVERY member, so a 4-product bundle needs 4 selections
    // before it can convert. Without these we cannot separate "nobody engages
    // the widget" from "people engage and abandon the size grid" — opposite
    // problems with opposite fixes. Each fires at most once per render.
    var engagedFired = false;
    var readyFired = false;

    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        sel.dataset.userSet = '1'; // their own pick; the page picker never overwrites it
        if (!engagedFired) {
          engagedFired = true;
          trackEvent('size_select', rule, { required: selects.length });
        }
        var chosen = 0;
        selects.forEach(function (s) { if (s.value) chosen++; });
        if (!readyFired && chosen === selects.length) {
          readyFired = true;
          trackEvent('bundle_ready', rule, { required: selects.length });
        }
        checkAllSizesSelected(selects, addBtn);
      });
    });
    // Pre-selected sizes never fire a change event, so the button would stay
    // disabled on a grid that is already complete. Evaluate once after wiring.
    checkAllSizesSelected(selects, addBtn);

    // The shopper picks a size on the page's own picker AFTER the widget has
    // rendered (the usual order). Carry it into every member they have not
    // sized themselves: the page product always, same-class members on an
    // exact in-stock match. The theme updates the form's hidden id a tick
    // after the change, so read it on the next frame.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || (t.classList && t.classList.contains('po-bundle-size-btn'))) return;
      if (t.closest && t.closest('.po-bundle-widget')) return;
      setTimeout(function () {
        var before = mainSizePicked;
        mainSizePicked = true;
        var wanted = selectedMainSize();
        if (!wanted) { mainSizePicked = before; return; }
        selects.forEach(function (sel, i) {
          if (sel.dataset.userSet === '1' || sel.style.display === 'none') return;
          var prod = products[i];
          var same = prod.handle === ph || (pageClass && garmentClass(prod) === pageClass);
          if (!same) return;
          for (var k = 0; k < sel.options.length; k++) {
            var o = sel.options[k];
            if (o.value && String(o.textContent).trim() === wanted) {
              sel.value = o.value; sel.dataset.preselected = '1'; break;
            }
          }
        });
        checkAllSizesSelected(selects, addBtn);
      }, 60);
    }, true);

    addBtn.addEventListener('click', function () { handleAddToCart(selects, products, rule, addBtn); });

    var isDesktop = window.matchMedia && window.matchMedia('(min-width: 769px)').matches;
    var inserted = false;
    if (isDesktop) {
      var productBlock = document.querySelector('.product, .product-single, .product-template');
      if (productBlock && productBlock.parentNode) {
        widget.classList.add('po-bundle-widget--desktop');
        productBlock.parentNode.insertBefore(widget, productBlock.nextSibling);
        inserted = true;
      }
    }
    if (!inserted) {
      var accordions = document.querySelectorAll('.product-info__accordion');
      var anchor = accordions.length ? accordions[accordions.length - 1] : null;
      if (anchor && anchor.parentNode) {
        anchor.parentNode.insertBefore(widget, anchor.nextSibling);
        inserted = true;
      } else {
        var addToCart = document.querySelector('form[action="/cart/add"], form[action*="/cart/add"], .product-form, .product__form-wrapper');
        if (addToCart && addToCart.parentNode) {
          addToCart.parentNode.insertBefore(widget, addToCart.nextSibling);
          inserted = true;
        } else {
          var descEl = document.querySelector('.product__description, .product-single__description, [data-product-description], .product-form__description');
          if (descEl && descEl.parentNode) { descEl.parentNode.insertBefore(widget, descEl.nextSibling); inserted = true; }
        }
      }
    }
    // Guaranteed visible fallback — never leave the widget unmounted.
    if (!inserted) {
      var fallbacks = ['.product-info', '.product__info-wrapper', '.product__info', '.product-single__meta', 'main'];
      for (var fi = 0; fi < fallbacks.length; fi++) {
        var c = document.querySelector(fallbacks[fi]);
        if (c) { c.appendChild(widget); inserted = true; break; }
      }
      if (!inserted) document.body.appendChild(widget);
    }
    var prefilled = 0;
    selects.forEach(function (s) { if (s.dataset.preselected === '1') prefilled++; });
    whenSeen(widget, function () {
      trackEvent('impression', rule, bundleMeta(products, {
        product_count: products.length,
        prefilled: prefilled,
        required: selects.length
      }));
    });
  }

  function checkAllSizesSelected(selects, addBtn) {
    var allSelected = true;
    selects.forEach(function (sel) { if (!sel.value) allSelected = false; });
    addBtn.disabled = !allSelected;
  }

  function handleAddToCart(selects, products, rule, addBtn) {
    var pageProduct = getPageProduct();
    var trigger = pageProduct && pageProduct.id ? String(pageProduct.id) : '';
    var items = [];
    selects.forEach(function (sel) {
      if (sel.value) {
        var member = products[parseInt(sel.dataset.productIdx, 10)] || null;
        var props = {
          _po_widget: 'bundle',
          _po_widget_id: BUNDLE_WIDGET_ID,
          _po_rule_id: rule.id || '',
          // Learning loop: which page (trigger) drove this bundle conversion.
          _po_trigger: trigger
        };
        // 5yr- (sale) members carry no _po_discount: they count toward the
        // bundle's 3 lines but are never discounted (see header).
        if (!isSaleMember(member, rule)) props._po_discount = rule.discount_percent || 15;
        items.push({ id: parseInt(sel.value, 10), quantity: 1, properties: props });
      }
    });
    if (items.length !== selects.length) return;
    addBtn.disabled = true; addBtn.textContent = 'ADDING…';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin', body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error('Cart add failed'); return r.json(); })
      .then(function () {
        addBtn.textContent = 'ADDED!';
        trackEvent('click', rule, bundleMeta(products, { item_count: items.length }));
        document.dispatchEvent(new CustomEvent('po:cart:added', { bubbles: true, detail: { source: 'bundle', rule_id: rule.id, items: items } }));
        setTimeout(function () { addBtn.textContent = 'ADD TO CART'; addBtn.disabled = false; }, 2000);
      })
      .catch(function (err) {
        console.error('[BundleSave] Cart add error:', err);
        addBtn.textContent = 'ADD TO CART'; addBtn.disabled = false;
      });
  }

  // ─── Init — read the bundle from the product-metafield bridge ────────────────
  function init() {
    if (window.location.pathname.indexOf('/products/') === -1) return;
    var data = window.PO_BUNDLE;
    if (!data || !data.products || !data.products.length) return;

    var pageProduct = getPageProduct();
    var saleHandles = {};
    data.products.forEach(function (m) { if (m && m.sale && m.handle) saleHandles[m.handle] = true; });
    var rule = {
      id: 'bundle-meta',
      discount_percent: (data.discount_percent != null ? data.discount_percent : 15),
      heading: data.heading || 'BUNDLE & SAVE',
      sale_handles: saleHandles
    };

    var promises = data.products.map(function (m) {
      return fetchProductByHandle(m.handle).catch(function () { return null; });
    });
    Promise.all(promises).then(function (full) {
      var ph = pageProduct && pageProduct.handle;
      // Sold out (every variant unavailable) never shows (Chris 2026-09-28:
      // pitcher-mom-hat pre-selected its sold-out hat and ADD failed). When the
      // page's own product is sold out there is nothing to bundle, so hide the
      // widget; a sold-out member drops out and the stored 4th fills its slot.
      var pageMember = full.filter(function (p) { return p && p.handle === ph; })[0];
      if (pageMember && !pageMember.available) return;
      var members = full.filter(function (p) { return p && p.available && !isPreorderProduct(p); });
      // Three buyable members or nothing: the bundle-pricing Function pays only
      // on 3+ bundle lines, so a 2-member bundle would promise a saving it never gives.
      if (members.length < 3) return;
      // Pin the page's current product to slot 1 if it's in the bundle.
      members.sort(function (a, b) {
        if (a.handle === ph) return -1;
        if (b.handle === ph) return 1;
        return 0;
      });
      renderWidget(members.slice(0, 3), rule);  // show 3 (the Function's min); 4th stored as in-stock fallback
    }).catch(function (err) { console.error('[BundleSave] load error:', err); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
